//Imports
  // React
	import { Link } from 'react-router-dom'
  //Icons
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faInstagram, faFacebook, faWhatsapp } from "@fortawesome/free-brands-svg-icons"
  import { faPhone, faMapLocation, faClock } from "@fortawesome/free-solid-svg-icons"




// snippet: rafce

const Footer = ( ) => {

  // Combos option
	let subNavClosed = true;
	// Click en button
	const subNav = () => {
    const navElements = document.getElementsByClassName('footer-nav')[0];
		const subNavElements = document.getElementsByClassName('footer-subNav')[0];
		if(subNavClosed){
      subNavClosed = false;
      subNavElements.style.display = "flex";
      navElements.style.display = "none";
		}
		else{
      subNavElements.style.display = "none";
			navElements.style.display = "flex";
      subNavClosed = true;
		}
	}
	// Click afuera
	window.addEventListener('click', function(e){
    const navElements = document.getElementsByClassName('footer-nav')[0];
		const subNavElements = document.getElementsByClassName('footer-subNav')[0];
		const subNavButton = document.getElementsByClassName('footer-nav-element')[4];
		if(!subNavElements.contains(e.target) && !subNavButton.contains(e.target)){
      subNavElements.style.display = "none";
			navElements.style.display = "flex";
      subNavClosed = true;
		}
	})


  return (
    <div className="footer">
      <div className="footer-container">
        <ul className="footer-nav">
          <li className="footer-nav-element"><Link to="/tienda">Inicio</Link></li>
          <li className="footer-nav-element"><Link to="/tienda/productos">Productos</Link></li>
          <li className="footer-nav-element"><Link to="/tienda/combos">Combos</Link></li>
          <li className="footer-nav-element"><a href="https://cotillonscraft.com.ar/nosotros"  target="_blank" rel="noopener noreferrer">Nosotros</a></li>
          <li className="footer-nav-element" onClick={subNav}>Legal</li>
        </ul>
        <ul className="footer-subNav">
          <li className="footer-nav-element"><a href="https://cotillonscraft.com.ar/legal/aviso-legal" target="_blank" rel="noopener noreferrer">Aviso Legal</a></li>
          <li className="footer-nav-element"><a href="https://cotillonscraft.com.ar/legal/politica-de-privacidad" target="_blank" rel="noopener noreferrer">Política de Privacidad</a></li>
          <li className="footer-nav-element"><a href="https://cotillonscraft.com.ar/legal/politica-de-cookies" target="_blank" rel="noopener noreferrer">Política de Cookies</a></li>
          <li className="footer-nav-element"><a href="https://cotillonscraft.com.ar/legal/condiciones-generales" target="_blank" rel="noopener noreferrer">Condiciones Generales</a></li>
          <li className="footer-nav-element"><a href="https://wa.me/5492216194481?text=Hola.%20Quisiera%20cancelar%20un%20pedido%20realizado" target="_blank" rel="noopener noreferrer">Botón de Arrepentimiento</a></li>
        </ul>
        <div className="footer-contact">
          <div className="footer-contact-element">
            <FontAwesomeIcon icon={ faPhone } />
            <a href="tel:+542214578938" target="_blank" rel="noopener noreferrer">
              <h4>0221 457-8938</h4>
            </a>
          </div>
          <div className="footer-contact-element">
            <FontAwesomeIcon icon={ faWhatsapp } />
            <a href="https://wa.me/5492216194481" target="_blank" rel="noopener noreferrer">
              <h4>+54 9 221 619-4481</h4>
            </a>
          </div>
          <address className="footer-contact-element">
            <FontAwesomeIcon icon={ faMapLocation } />
            <a href="https://goo.gl/maps/rCZuz9y39UtXPBwa8" target="_blank" rel="noopener noreferrer">
                <h4>Calle 71 Nº 1530, La Plata.</h4>
            </a>
          </address>
          <div className="footer-contact-element">
            <FontAwesomeIcon icon={ faClock } />
            <p>Lunes a Viernes de 8 a 16 hs.</p>
          </div>
        </div>
      </div>
      <div className="footer-social">
        <div className="footer-social-element">
          <a href="https://www.instagram.com/cotillonscraft/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={ faInstagram } size="2x" />
            <h5>Instagram</h5>
          </a>
        </div>
        <div className="footer-social-element">
          <a href="https://www.facebook.com/cotillon.scraft" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={ faFacebook } size="2x" />
            <h5>Facebook</h5>
          </a>
        </div>
      </div>
      <div className="footer-payment">
        <p>
          Aceptamos transferencia bancaria<br />
          10% off por pago en efectivo<br />
          Aceptamos todas las tarjetas
        </p>
      </div>
    </div>
  )
}

export default Footer
